var renderProductAlsoBoughtDefault = function (SC, render) {
    var recommendedItems = [];
    for (var i = 0, l = SC.page.products.length; i < l; i++) {
        recommendedItems.push(SC.page.products[i]);
    }

    var renderItem = function(html) {
        var $recs_wrapper = $('#alsobought-recs');

        if ($recs_wrapper.length) {
            $recs_wrapper.append(html);
            var $products = $recs_wrapper.children('.product');

            $products.each(function () {
                getImageSrc($(this));
                translateJudgemeBadge($(this));
            });
        }
    }

    if (recommendedItems.length > 0) {
        $(recommendedItems).each(function (i, item) {
            let itemLink = item.link;
            let separator = '?';
            if (itemLink.includes('?')) {
                separator = '&';
            }


            $.get(item.link + separator +'view=grid-item').then(function (html) {
                if (!html.includes('Unavailable')) {
                    return html;
                }
            }).then(function (html) {
                var html = html.replace('data-mh="product"', 'data-scarabitem='+item.id+  ' data-mh="product"');
                html = html.replace('large--one-third', 'large--one-quarter');
                renderItem(html);
            });
        });
    }
};

var renderRecommendedByCollection = function (SC, render) {
    var renderItem = function(html) {
        var $recs_wrapper = $('#collection-recs');

        if ($recs_wrapper.length) {
            var badge = '<span class="recommended">Recommended from other categories</span>';
            $recs_wrapper.append(html);
            var $products = $recs_wrapper.children('.product');

            $products.each(function () {
                $(this).find('#grid_badge_container').html(badge);
                getImageSrc($(this));
                translateJudgemeBadge($(this));
            });
        }
    }

    var recommended_items = [];
    for (var i = 0, l = SC.page.products.length; i < l; i++) {
        recommended_items.push(SC.page.products[i]);
    }

    if (recommended_items.length > 0) {
        var shuffled_items = shuffleArray(recommended_items);
        var limit = window.recommended_limit;
        var rendered_items = 0;

        $(shuffled_items).each(function (i, item) {
            $.get(item.link + '?view=grid-item').then(function (html) {
                if (!html.includes('Unavailable')) {
                    return html;
                }
            }).then(function (html) {
                if (rendered_items < limit && html) {
                    rendered_items++;
                    var html = html.replace('data-mh="product"', 'data-scarabitem='+item.id+  ' data-mh="product"');
                    renderItem(html);

                    if (Cookies.get('display') === 'list') {
                        changeToList();
                    }
                }
            });
        });
    }
}

var getImageSrc = function($product) {
    var $product_image = $product.find('img');
    var $product_image_src = $product_image.attr('data-src');

    if ($product_image.attr('src') !== $product_image_src) {
        $product_image.css('opacity', 0)
        $product_image.attr('src', $product_image_src)

        setTimeout(function (e) {
            return function () {
                $product_image.css('opacity', 1)
            }
        }($product_image), 1000);
    }
}

var renderProductAlsoBoughtClothing = function(SC, render) {
  var $recs_wrapper = $('#cl-collection-recs');

  if (!$recs_wrapper) {
    return;
  }

  var recommended_items = [];
  for (var i = 0, l = SC.page.products.length; i < l; i++) {
    recommended_items.push(SC.page.products[i]);
  }

  /*
   * Mock
  recommended_items = [{
      link: "https://shopdev.biotechusa.hu/products/bella-noi-sport-melltarto-bordo"
  }, {
      link: "https://shopdev.biotechusa.hu/products/bella-noi-sportmelltarto-sotetkek"
  }, {
      link: "https://shopdev.biotechusa.hu/products/bella-noi-sportmelltarto-vilagoskek"
  }, {
      link: "https://shopdev.biotechusa.hu/products/melanie-noi-leggings"
  }, {
      link: "https://shopdev.biotechusa.hu/products/joyce-capri"
  }];
  */

  if (recommended_items.length > 0) {
    var shuffled_items = shuffleArray(recommended_items);
    var rendered_items = 0;
    var promises = [];

    $(shuffled_items).each(function(i, item) {
      var promise = $.get(item.link + '?view=cl-card-variants-container').then(function(html) {
        if (!html.includes('Unavailable') && html) {
          rendered_items++;
          html = html.replace('data-mh="product"', 'data-scarabitem=' + item.id + ' data-mh="product"');
          $recs_wrapper.append(html);
        }
      });

      promises.push(promise);
    });

    Promise.allSettled(promises).then(function() {
      var $recs_section = $('.cl-product-recommender');
      $recs_section.length && $recs_section.show();
      initCardSlider('.cl-product-recommender .cl-row__carousel--card', '.cl-product-recommender .cl-carousel__nav');
      initColorSelectorCarousels();
    });
  }
};

var renderProductAlsoBought = function(SC, render) {
    switch (window.also_bought_recommender) {
        case 'clothing':
            var alsoBoughtRecommenderHandler = renderProductAlsoBoughtClothing;
            break;
        default:
            var alsoBoughtRecommenderHandler = renderProductAlsoBoughtDefault
    }

    alsoBoughtRecommenderHandler(SC, render);
}

var shuffleArray = function(inputArray) {
  return inputArray.sort(function() {
    return 0.5 - Math.random();
  });
}